export const WeeklyOfferChecker = (
	checkin: string | null,
	checkout: string | null,
) => {
	if (!checkin || !checkout) {
		return false;
	}
	const checkInDay = new Date(checkin).getDay();
	const checkOutDay = new Date(checkout).getDay();

	if (
		checkInDay >= 1 &&
		checkInDay <= 5 &&
		checkOutDay >= 1 &&
		checkOutDay <= 5
	) {
		return true;
	}
	return false;
};
